import AppTheme from "../../../theme/AppTheme";
import { dataGridCustomizations } from "../../../theme/customizations";
import { CssBaseline, Grid, Box } from "@mui/material";
import DishManagementGrid from "./Grid/DishManagementGrid";
const DishManagement = (props: { disableCustomTheme?: boolean }) => {
  const xThemeComponents = {
    ...dataGridCustomizations,
  };
  return (
    <>
      <AppTheme {...props} themeComponents={xThemeComponents}>
        <CssBaseline enableColorScheme />
        <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
          <Grid
            container
            columns={12}
            spacing={2}
            sx={{ mb: (theme) => theme.spacing(2), width: "auto" }}
          >
            <DishManagementGrid />
          </Grid>
        </Box>
      </AppTheme>
    </>
  );
};

export default DishManagement;
